export const institutionsQuery = `
  institutions(filter: $filter, skip: $skip, take: $take) {
    crmId
    prospectingId
    name
  }`;

export const contactsQuery = `
  contacts(filter: $filter, skip: $skip, take: $take) {
    crmId
    prospectingId
    firstName
    lastName
    companyName
    email
    crmCompanyId
    prospectingCompanyId
  }`;

export const securitiesQuery = `securities(filter:$filter, skip:$skip, take:$take){
    securityId,
    securityName,
    ticker,
    exchangeTrade
  }`;

export const contactsByEmailQuery = `
  contacts(filter: $filter, skip: $skip, take: $take, searchByEmail: $searchByEmail, exactEmailMatch: $exactEmailMatch,
   searchByEmailAndName: $searchByEmailAndName) {
    crmId
    prospectingId
    firstName
    lastName
    companyName
    email
    crmCompanyId
    prospectingCompanyId
}`;
